import { render, staticRenderFns } from "./assetCategoryStatistics.vue?vue&type=template&id=8de814b2&scoped=true"
import script from "./assetCategoryStatistics.vue?vue&type=script&lang=js"
export * from "./assetCategoryStatistics.vue?vue&type=script&lang=js"
import style0 from "./assetCategoryStatistics.vue?vue&type=style&index=0&id=8de814b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de814b2",
  null
  
)

export default component.exports